import React from 'react';

import { ActionIcon, Card, Divider, Grid, Text, Tooltip } from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons-react';

import type { CardData } from './interfaces';
import { numberWithCommas } from './interfaces';

interface SummaryCardProps {
  cardTitle: string;
  cardData: CardData[];
  cardInfo?: string;
}
export function SummaryStatisticCard(props: SummaryCardProps) {
  return (
    <Card
      withBorder
      p="xl"
      style={{
        height: '100%',
        borderRadius: 5,
      }}
    >
      <Card.Section>
        <Text mb="sm" ta="center" fw={500} c="dimmed">
          {props.cardTitle}
          {props.cardInfo ? (
            <Tooltip label={props.cardInfo} classNames={{ tooltip: 'help-tooltip', arrow: 'help-tooltip-arrow' }} withinPortal>
              <ActionIcon variant="subtle" size="sm" aria-label={`More info about ${props.cardTitle}`}>
                <IconInfoCircle size={12} color="grey" />
              </ActionIcon>
            </Tooltip>
          ) : null}
        </Text>
        <Divider my="xs" />
        {props.cardData.map((item: CardData) => {
          return (
            <Grid key={item.label} style={{ mt: 1 }}>
              <Grid.Col span="content" style={{ ml: 2 }}>
                {item.info ? (
                  <Tooltip label={item.info} classNames={{ tooltip: 'help-tooltip', arrow: 'help-tooltip-arrow' }} withinPortal>
                    <Text fw={500} style={{ cursor: 'default', textDecoration: 'underline dotted', textUnderlineOffset: 3 }}>
                      {item.label}
                    </Text>
                  </Tooltip>
                ) : (
                  <Text fw={500}>{item.label}</Text>
                )}
              </Grid.Col>
              <Grid.Col
                span="auto"
                w="auto"
                mb="md"
                style={{
                  marginLeft: 0.5,
                  marginRight: 0.5,
                  borderBottom: 2.4,
                  borderBottomStyle: 'dotted',
                  borderColor: '#dee2e6',
                }}
              />
              <Grid.Col span="content">
                <Text ta="right" fw={500} data-testid={`summary-statistic-${item.label}`}>
                  {item?.value ? numberWithCommas(item.value as number) : '-'}
                </Text>
              </Grid.Col>
            </Grid>
          );
        })}
      </Card.Section>
    </Card>
  );
}
